import Layout from '@/layout';
var systemSettingRouter = {
  path: '/system-setting',
  component: Layout,
  redirect: '/system-setting/pay-setting',
  name: 'system-setting',
  alwaysShow: true,
  meta: {
    title: '支付设置',
    icon: 'clipboard'
  },
  children: [{
    path: 'pay-setting',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/pay-setting/index.vue'], resolve);
    },
    name: 'pay-setting',
    meta: {
      title: '支付配置',
      icon: ''
    }
  }, {
    path: 'msg-setting',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/msg-setting/index.vue'], resolve);
    },
    name: 'msg-setting',
    meta: {
      title: '短信配置',
      icon: ''
    }
  }, {
    path: 'object-storage',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/object-storage/index.vue'], resolve);
    },
    name: 'object-storage',
    meta: {
      title: '对象存储',
      icon: ''
    }
  }, {
    path: 'quick-settings',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/quick-settings/index.vue'], resolve);
    },
    name: 'quick-settings',
    meta: {
      title: '系统设置-快递设置',
      icon: ''
    }
  }, {
    path: 'registration-settings',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/registration-settings/index.vue'], resolve);
    },
    name: 'registration-settings',
    meta: {
      title: '系统设置-注册设置',
      icon: ''
    }
  }, {
    path: 'bank-cards-ettings',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/bank-cards-ettings/index.vue'], resolve);
    },
    name: 'bank-cards-ettings',
    meta: {
      title: '系统设置-银行卡设置',
      icon: ''
    }
  }, {
    path: 'about-us',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/about-us/index.vue'], resolve);
    },
    name: 'about-us',
    meta: {
      title: '关于我们',
      icon: ''
    }
  }, {
    path: 'service',
    component: function component(resolve) {
      return require(['@/views/my-create/system-setting/service/index.vue'], resolve);
    },
    name: 'service',
    meta: {
      title: '客服人员配置',
      icon: ''
    }
  }]
};
export default systemSettingRouter;